module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.playItem == null) ? _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['All'].concat(_vm.categories),
      "label": "Select",
      "light": "",
      "single-line": "",
      "auto": "",
      "item-text": "name",
      "item-value": "name"
    },
    model: {
      value: (_vm.category),
      callback: function($$v) {
        _vm.category = $$v
      },
      expression: "category"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-right",
    staticStyle: {
      "font-size": "1.5em",
      "padding-top": "1em"
    },
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_vm._v("總瀏覽次數： " + _vm._s(_vm.totalCount))])], 1), _vm._v(" "), _vm._l((_vm.categories.filter(function (el) {
    return _vm.category === 'All' || (_vm.category !== 'All' && el === _vm.category)
  })), function(categoryArea) {
    return _c('section', {
      key: categoryArea.name,
      staticClass: "mb-5 bg--white"
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "xs10": ""
      }
    }, [_c('h4', [_vm._v(_vm._s(categoryArea.name) + " (" + _vm._s(categoryArea.count) + ")")])])], 1), _vm._v(" "), _c('v-row', {
      staticClass: "mt-3"
    }, _vm._l((_vm.filterPlace(categoryArea.name)), function(place, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "xs12": "",
          "sm4": ""
        }
      }, [_c('v-card', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.viewPlace(place)
          }
        }
      }, [_c('div', {
        staticClass: "pa-1"
      }, [_c('img', {
        staticStyle: {
          "max-width": "100%",
          "max-height": "300px"
        },
        attrs: {
          "src": place.coverUrl
        }
      })]), _vm._v(" "), _c('v-card-title', {
        attrs: {
          "primary-title": ""
        }
      }, [_c('div', [_c('div', {
        staticClass: "headline"
      }, [_vm._v(_vm._s(place.lessonName))]), _vm._v(" "), _c('span', {
        staticClass: "grey--text"
      }, [_vm._v("觀看次數： " + _vm._s(place.viewCount))])])])], 1)], 1)
    }))], 1)
  })], 2) : _c('div', {
    staticClass: "container"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs8": ""
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.playItem.lessonName))])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-right",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "floating": "",
      "small": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.playItem = null
      }
    }
  }, [_vm._v("X")])], 1)], 1), _vm._v(" "), _c('Player', {
    ref: "Player",
    attrs: {
      "url": _vm.playItem.videoUrl
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67752238"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlaceList.vue
// module id = 783
// module chunks = 1